import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Vilamoura Hen Party Cruise · Private Yacht · Morningstar";
const DESC = "Private hen party cruise in Vilamoura aboard Morningstar — sparkling wine, DJ or saxophonist upgrades, sunset and swim stops. Up to 18 guests, 100% private boat.";
const PATH = "/vilamoura-hen-party-cruise";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/vilamoura-hen-party-cruise")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Hen Party Cruise · Vilamoura · Algarve",
        title: "Vilamoura hen party cruise aboard ",
        titleAccent: "Morningstar.",
        sub: "A 100% private yacht, sparkling wine on arrival, DJ or saxophone upgrades and a sunset to remember. Up to 18 guests, customised playlist.",
        ctaPrimary: "View hen cruises",
        ctaSecondary: "Plan the hen do",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "hen party cruise Vilamoura, hen do Vilamoura, bachelorette boat Vilamoura, hen party Algarve, hen cruise Portugal",
      altPath: { en: PATH, pt: "/pt/cruzeiro-despedida-solteira-vilamoura" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Vilamoura Hen Party Cruise",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Hen Party Cruise Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});
